var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoryBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 7,
    height: 4,
    rx: 2,
    fill: "#2A2A2B",
    stroke: "#2A2A2B",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 11,
    width: 7,
    height: 10,
    rx: 2.5,
    fill: "#2A2A2B",
    stroke: "#2A2A2B",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 4,
    width: 7,
    height: 10,
    rx: 2.5,
    fill: "#2A2A2B",
    stroke: "#2A2A2B",
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 17,
    width: 7,
    height: 4,
    rx: 2,
    fill: "#2A2A2B",
    stroke: "#2A2A2B",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryBlack);
export default __webpack_public_path__ + "static/media/Category_black.dd89d4a47e525e62542b6d7414ae4eea.svg";
export { ForwardRef as ReactComponent };